export const commitmentsTableColumns = [
  { title: 'Strategy', key: 'name', width: 16, keySort: 'name' },
  { title: 'Asset Class', key: 'assetClass', width: 14, keySort: 'asset class' },
  { title: 'Committed Capital', key: 'committedCapital', width: 14, keySort: 'committed capital' },
  { title: '%Called', key: 'percentCalled', width: 14, keySort: 'called' },
  { title: 'Distribution to Date', key: 'distributionsToDate', width: 14, keySort: 'distribution to date' },
  { title: 'Market Value', key: 'marketValue', width: 14, keySort: 'market value' },
  { title: 'Status', key: 'status', width: 14, keySort: 'status' }
];

export const commitmentsMobileTableSort = [
  {
    title: 'Commitment • A -> Z',
    key: 'name',
    asc: true
  },
  {
    title: 'Commitment • Z -> A',
    key: 'name',
    asc: false
  },
  {
    title: 'Asset Class • A -> Z',
    key: 'assetClass',
    asc: true
  },
  {
    title: 'Asset Class • Z -> A',
    key: 'assetClass',
    asc: false
  },
  {
    title: 'Committed Capital • Max -> Min',
    key: 'committedCapital',
    asc: false
  },
  {
    title: 'Committed Capital • Min -> Max',
    key: 'committedCapital',
    asc: true
  },
  {
    title: '%Called • Max -> Min',
    key: 'percentCalled',
    asc: false
  },
  {
    title: '%Called • Min -> Max',
    key: 'percentCalled',
    asc: true
  },
  {
    title: 'Distribution to Date • Max -> Min',
    key: 'distributionsToDate',
    asc: false
  },
  {
    title: 'Distribution to Date • Min -> Max',
    key: 'distributionsToDate',
    asc: true
  },
  {
    title: 'Market Value • Max -> Min',
    key: 'marketValue',
    asc: false
  },
  {
    title: 'Market Value • Min -> Max',
    key: 'marketValue',
    asc: true
  },
  {
    title: 'Status • A -> Z',
    key: 'status',
    asc: true
  },
  {
    title: 'Status • Z -> A',
    key: 'status',
    asc: false
  }
];
